/// <reference path="../../../../../../../typings/index.d.ts" />
///<reference path="../../input-handler.ts"/>
///<reference path="../../converters/email.converter.ts"/>
///<reference path="../../converters/phone.converter.ts"/>


// Used as an attribute on inputs so that when enter is hit soft keyboards on phones and tablets will disappear
module Meevo.Components.Controls.HideInput {
    'use strict';

    class HideInputComponent {

        mhiOptions?: IHideInputDirectiveOptions;
        converter: AvailableConverters;

        inputHandler: InputHandler;
        converterEntity: IStringConverter;

        constructor(private $element: angular.IAugmentedJQuery,
                    private $scope: ng.IScope) {
            const Converter: IStringConverterStatic = convertersList[this.converter];

            if (!Converter) {
                throw new Error(`Unknown converter "${this.converter}"`);
            }

            this.converterEntity = new Converter(this.mhiOptions);
            this.inputHandler = new InputHandler(this.$element.find('input')[0] as HTMLInputElement, this.converterEntity);
        }

        setWatchers(model: ng.INgModelController) {
            this.$scope.$watch(() => this.mhiOptions, () => {
                this.inputHandler.onOptionsChanged();
            }, true);

            // update model value from the input handler
            this.$scope.$watch(() => this.inputHandler.modelValue, (newValue: string) => {
                if (this.converterEntity.isEqual(newValue, model.$viewValue)) return;

                model.$setViewValue(_.clone(newValue));
            }, true);

            this.$scope.$watch(() => model.$viewValue, (newValue: any) => {
                if (this.converterEntity.isEqual(newValue, this.inputHandler.modelValue)) return;

                this.inputHandler.updateValue(newValue);
            });
        }

        toggleVisibility() {
            this.inputHandler.toggleVisibility();
        }

    }

    class MeevoHideInputDirective implements ng.IDirective {

        restrict = 'E';
        bindToController = true;
        controllerAs = '$ctrl';
        templateUrl = 'app/components/controls/hideInput/components/hide-input/hideInput.directive.html';
        controller = [
            '$element',
            '$scope',
            HideInputComponent
        ];
        scope = {
            name: '@',
            converter: '@',
            mhiOptions: '='
        };

        require = [
            'meevoHideInput',
            '^ngModel'
        ];

        public static factory() {
            const directive = () => {
                return new MeevoHideInputDirective();
            };

            return directive;
        }

        link(scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) {
            self.setWatchers(ngModel);
        }
    }

    angular.module('meevo.components.controls.HideInput')
        .directive('meevoHideInput', MeevoHideInputDirective.factory());

}
